export function cubiCasaButonShouldBeDisabled(user: any) {
    return user.id === undefined;
}
